import React, { useState } from 'react'
import Input from './Input'
import styled from '@emotion/styled'
import 'react-phone-number-input/style.css'
import Image from 'next/image'
import PhoneInput, { getCountryCallingCode } from 'react-phone-number-input'


const PhoneNumberInput = (props) => {
  const [country, setCountry] = useState('US')

  return (
    <PhoneInputWrapper>
      <PhoneInput
        defaultCountry='US'
        onCountryChange={setCountry}
        country={country}
        inputComponent={CustomInput}
        countrySelectComponent={CustomCountrySelect}
        international={false}
        withCountryCallingCode={false}
        countryCallingCodeEditable={false}
        {...props}
      />
    </PhoneInputWrapper>
  )
}
const CustomCountrySelect = ({ value, onChange, options, disabled, readOnly, ...rest }) => {
  const handleChange = (e) => {
    onChange(e.target.value === 'ZZ' ? undefined : e.target.value)
  }

  return (
    <CountrySelectWrapper
      onClick={() => document.getElementById('custom-country-select')?.click()}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        position: 'relative',
        cursor: 'pointer',
        width: 'fit-content'
      }}
    >
      <Image
        height={16}
        width={24}
        src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${value}.svg`}
        alt={value}
      />
      <span>
        { value && (
          `+${getCountryCallingCode(value)}`
        )}
      </span>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
        <path d="M5.79584 0.309146H11.5917L5.79584 5.82349L-2.19345e-05 0.309146H5.79584Z" fill="#202020"/>
      </svg>

      <select
        { ...rest }
        style={{ opacity: 0, position: 'absolute', inset: 0 }}
        value={value}
        onChange={handleChange}
        disabled={disabled || readOnly}
        readOnly={readOnly}
      >
        {options.map(({ value, label, divider }) => (
          <option
            key={divider ? '|' : value}
            value={divider ? '|' : value}
            disabled={!!divider}
            style={divider ? {
              fontSize: '1px',
              backgroundColor: 'currentColor',
              color: 'inherit'
            } : undefined}
          >
            {label}
          </option>
        ))}
      </select>
    </CountrySelectWrapper>
  )
}

/*
 * CustomInput overrides PhoneInput input component with our styled one
 * pass state prop to PhoneNumberInput which gets passed to CustomInput
 * state: { active, value, error }
*/
const CustomInput = React.forwardRef((props, ref) => {
  const isActive = !!props?.value && !props.touched

  return (
    <InputContainer>
      <Input
        ref={ref}
        value={props?.value}
        {...props}
      />
      { !props?.hideLabel && (
        <label className={(isActive) ? 'active' : ''}>Mobile Number</label>
      )}
    </InputContainer>
  )
})


const PhoneInputWrapper = styled.div`
  .PhoneInput {
    gap: 15px;
  }

  .PhoneInputInput {
    height: 50px;
    border-bottom: 1px solid black !important;
  }
`

const InputContainer = styled.div`
  width: 100%;
  position: relative;
  margin-left: 10;

  label {
    color: #000;
    opacity: 0.5;
    position: absolute;
    font-family: 'Euclid';
    font-size: 18px;
    // z-index: -1;
    top: 10px;
    transition: all .1s ease;

  }
  .active {
    font-size: 11px;
    top: -2px;
    left: 0;
    line-height: 120%;
    letter-spacing: 0.22px;
  }

  input {
    height: 100%;
    box-sizing: border-box;
    width: 100%;
    border-bottom: 1px solid #E8E2E1 !important;
    font-size: 18px;
    font-family: Euclid;
    line-height: 120%;
    border-radius: 0;
    letter-spacing: 0.36px;
    padding: 12px 0;
    position: relative;
    background-color: transparent;
    &:focus {
      outline: none;
    }
  }
`

const CountrySelectWrapper = styled.div`
  display: flex;
  alignItems: center;
  gap: 8;
  position: relative;
  cursor: pointer;
  width: fit-content;
  height: 50px;
  border-bottom: 1px solid black !important;
`

export default PhoneNumberInput
